import RegisterPress from './RegisterPress';

export default RegisterPress;
